import useDebounce from "hooks/others/useDebounce";
import { useInfiniteQuery } from "react-query";
import { GetVacationList } from "services/workSchedule";
export default function UseGetVacationList(
  obj: { search: string; status?: number},
  enabled: boolean
) {
  const { newParam: searchParam } = useDebounce(obj.search);
  const { newParam: statusParam } = useDebounce(obj.status?.toString() || "");
  return useInfiniteQuery(
    ["vacation-list", searchParam, statusParam],
    
    async ({ pageParam = 1 }) => GetVacationList(pageParam, searchParam, statusParam),
    {
      enabled,
      getNextPageParam: (lastPage) =>
        lastPage.meta.nextPageUrl ? lastPage.meta.currentPage + 1 : undefined,
    }
  );
}